import { FormControl, FormHelperText, InputLabel, Select, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormStyles } from "../form.styles";

export const DropDownMUI = (props: any) => {
  const {
    disabled,
    value,
    label,
    watchingProperties,
    watch,
    onChange,
    options,
    getValues,
    computed,
    placeholder,
    error,
    dataTestId,
    selectStyle,
    id,
  } = props;
  const classes = useFormStyles();

  const [data, setData] = useState([] as any);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!options) return;

    if (Array.isArray(options)) {
      setData(options);
    } else {
      options().then((res: any) => {
        const newData = res && Array.isArray(res) ? res : [];
        setData(newData);
      });
    }
  }, [options]);

  useEffect(() => {
    const subscription = watchingProperties((value: any, { name, type }: { name: string; type: any }) => {
      if (watch?.includes(name)) {
        setLoading(true);
        computed(getValues()).then((newData: any) => {
          setData(newData);
          setLoading(false);
        });
      }
    });
    return () => subscription?.unsubscribe();
  }, [computed, getValues, watch, watchingProperties]);

  return (
    <FormControl error={!!error} className={classes.field} size="small" id="form-control-drop-down">
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        id={id}
        inputProps={{
          "data-testid": dataTestId ?? "",
          id: dataTestId,
        }}
        value={value}
        disabled={disabled || loading}
        label={label}
        onChange={(value) => onChange(value)}
        style={selectStyle}
      >
        {placeholder !== undefined && placeholder !== "" && (
          <MenuItem key={placeholder} value={placeholder} disabled>
            {placeholder}
          </MenuItem>
        )}

        {data.map((e: any) => (
          <MenuItem
            key={props.propertyValue ? e.id : e}
            value={props.propertyValue ? e.id : e}
            id={props.propertyLabel ? e.title : e}
          >
            {props.propertyLabel ? e.title : e}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};
